package com.tixforgigs.common.core.enums

enum class ClientType {
  ARAI_STOREFRONT,
  TEMPLATE_CONFIGURATOR
}